import { store } from './store';
import { debug, user, utils, localSwitch } from 'lib';

import get from 'lodash/get';
import set from 'lodash/set';
import giftLib from '../gift/gift';

const log = debug.create('animate');
const error = debug.create('animate:error');

let animateList = [];
let animateEnterList = [];
let carMaxNum = 3;
let isPlaying = false;

const push = (data) => {
  log(
    'push data:',
    data,
    'gift:',
    localSwitch.getSwitch('gift'),
    'enter:' + localSwitch.getSwitch('enterAnimation'),
  );
  if (!data) {
    return;
  }
  if ((data.gift || data.anim_type) && !localSwitch.getSwitch('gift')) {
    return;
  }
  if (data.enter && !localSwitch.getSwitch('enterAnimation')) {
    return;
  }

  if (data.enter) {
    if (MM.user.isSelf(data._id) || animateEnterList.length <= carMaxNum) {
      animateEnterList.push(data);
    }
  } else {
    if (data.isFirstPlay) {
      animateList = [data, ...animateList];
    } else {
      animateList.push(data);
    }
  }

  start();
};

const start = () => {
  if (animateList.length === 0 && animateEnterList.length === 0) {
    return;
  }
  if (isPlaying) {
    log('playing:', animateList.length, animateEnterList.length);
    return;
  }

  isPlaying = true;
  let data = animateList.shift() || animateEnterList.shift();
  log('start:', data, animateList.length, animateEnterList.length);
  let { gift, enter, text } = data;

  if (gift) {
    if (!localSwitch.getSwitch('gift')) {
      return next();
    }

    let giftUrl = gift.vap_url || gift.svga_pc_url || gift.swf_pc_url;
    let giftText = text || ''; // 谁送给谁

    // 左侧小区域  不走这个逻辑，默认
    // 0 全屏，1 上半区，2 下半区，3 左侧小区域
    let position =
      ['full', 'top', 'bottom', 'top', 'cover'][gift.animate_pos] || 'top';
    log('play gift:', position, gift);

    if (/\.mp4/gi.test(giftUrl) && gift.vap_config_url) {
      log('setVideoVpaAnimation gift', giftUrl, position);
      store.setVideoVapAnimation({
        url: giftUrl,
        configUrl: gift.vap_config_url,
        // url:'https://test-img.sumeme.com/swf/demo.mp4',
        // configUrl:'https://test-img.sumeme.com/swf/demo.json',
        // 'https://localhost.2339.com/v2/vap.mp4'
        // 'https://localhost.2339.com/v2/vapc.json'
        position,
        imgUser: get(data, 'from.pic'),
        imgAnchor: get(data, 'to.pic'),
        textUser: get(data, 'from.nick_name'),
        textAnchor: get(data, 'to.nick_name'),
        text: data.text,
      });
    } else if (/\.svga/gi.test(giftUrl)) {
      if (typeof gift.animate_pos !== 'undefined') {
        log('setVideoSvgaAnimation');
        store.setVideoSvgaAnimation(giftUrl, position);
      } else {
        log('setSvgaAnimation gift', giftUrl);
        store.setSvgaAnimation(giftUrl);
      }
    } else if (/\.swf/gi.test(giftUrl)) {
      store.setSvgaAnimation(giftUrl);
    } else {
      // if (gift.count < 50) {
      let opt = {
        pic: gift.pic_url,
        count: gift.count,
        name: gift.name,
      };
      log('addVideoGift:', opt);
      store.addVideoGift(opt);
      next();

      // } else {
      //   取消组合礼物动画
      //   log('setCanvasGift:', gift.count, gift.pic_url)
      //   store.setCanvasGift(gift.count, gift.pic_url)
      // }
    }
  } else if (enter) {
    if (!localSwitch.getSwitch('enterAnimation')) {
      next();
      return;
    }
    enter.position = 'cover';
    store.setVideoVapAnimation(enter);
  }
};

const showFlash = (domId, swf_url) => {
  log('showFlash', domId, swf_url);
  if (!swf_url) return;

  // _showReady();
  // MM.core.debug('play animatin:',swf_url)

  // 如果为本地调试模式则使用本地swf文件
  swf_url = swf_url.replace('test.2339.com/swf', 'test-flash.sumeme.com');
  swf_url = swf_url.replace('www.2339.com/swf', 'flash.sumeme.com');
  swf_url = swf_url.replace('test.flash', 'test-flash');
  swf_url = swf_url.replace('http:', location.protocol); //替换为当前网页的协议

  if (utils.isFlashEnabled()) {
    const isReady = (swf) => {
      return !!swf && (swf.isLoaded || swf.SetUrls);
    };
    const success = () => {};

    utils.insertSWF(
      swf_url,
      domId,
      '100%',
      '100%',
      isReady,
      success,
      stopFlash,
    );
  } else {
    log('flash disabled');
    stopFlash();
  }
};

const next = () => {
  isPlaying = false;
  start();
};

const stopFlash = () => {
  log('stopFlash');
  store.clearSvgaAnimation();
  next();
};

(function () {
  if (typeof window !== 'undefined') {
    // MM.live.animateController = { stopAnimation: _stop }
    // MM.live.stopAnimation = _stop;
    // Ttxy = { live: { stopAnimation: _stop } };
    set(window, 'MM.live.animateController.stopAnimation', stopFlash);
    set(window, 'MM.live.stopAnimation', stopFlash);
    set(window, 'Ttxy.live.stopAnimation', stopFlash);
    set(window, 'MM.live.animate.stop', stopFlash);
  }
})();

//  vpa 动画  _MMWidget.animate.testPush(120,1)
//  svga 普通全屏  _MMWidget.animate.testPush(604,1)
//  svga 视频全屏  _MMWidget.animate.testPush(604,1)

// ['full', 'top', 'bottom', 'top', 'cover']
// vap  full  167
// vap  top  无
// vap  bottom  无
// vap  cover  1190  1060  1079  1081  1150   960x720【2009  】

// svga  full  1086
// svga  top  868 1169 407 1170
// svga  bottom  852  858 860 877
// svga  cover  1068 1157

const testPush = (giftId, count) => {
  console.log('animatePlayer giftId:', giftId);
  push({
    gift: Object.assign({}, giftLib.getGift(giftId), {
      count: parseInt(count, 10),
    }),
    from: user.getUserInfo(),
    to: user.getUserInfo(),
  });
};

const testPushEnter = () => {
  push({
    enter: {
      url: 'https://test-img.sumeme.com/swf/video60667.mp4', //car.carGif,
      configUrl: 'https://test-img.sumeme.com/swf/vapc83516.json', //car.carJson,
      imgUser: 'https://test-img.sumeme.com/23/7/1516764526295.jpg',
      imgAnchor: '',
      textUser: '昵称昵称昵昵称昵',
      textAnchor: '',
      fontStyle: JSON.stringify({ color: '#FFFFFF', font: '26px PingFang' }),
    },
  });
};

export default {
  push,
  next,
  showFlash,
  testPush,
  testPushEnter,
};
